import isEmpty from 'lodash/isEmpty';

/**
 * Перевод объекта адреса в строку
 * @param obj
 */
export function addressToString({ city, street, house, building, flat }) {
    const result = [];

    Boolean(city) && (result.push(`г. ${city}`));
    Boolean(street) && (result.push(`ул. ${street}`));
    Boolean(house) && (result.push(`д. ${house}${building ? `/${building}` : ''}`));
    Boolean(flat) && (result.push(`кв. ${flat}`));

    return result.join(', ');
}

/**
 * Проверка наличия услуги на договоре
 * @param data obj
 * @param productID int
 * @param serviceID int
 * @returns {boolean}
 */
export function connectedProducts(data, productID, serviceID) {
    if (data && data.clientProducts && data.clientProducts.services) {
        const product = data.clientProducts.services.find(item => item.productId === productID);
        // услуга недоступна для подключения
        if (product?.terminalResources === null) {
 return false;
}

        const service = product?.terminalResources.find(item => item.id === serviceID);
        if (service && Object.keys(service).length > 0) {
            return true;
        } else {
            return false;
        }
    }
}

/**
 * Пполучение clientId из Google Tag Manager
 */
export const getClientId = () =>  {
    let clientId;
    try {
        clientId = window.ga ? window.ga.getAll()[0].get('clientId') : 'ga is not defined';
    } catch (e) {
        clientId = 'window.ga.getAll is not a function';
    }
    return clientId;
};

/**
 * Определяем есть ли в продуктах тарифы домофонии
 * productsInfoItem - экземпляр productInfo.p75
 */
export const hasProductServices = (serviceArr, productsInfoItem) => {
    if (serviceArr == null) {
        return false;
    }
    const hasMainServices = serviceArr.filter(service => [5, 12, 32, 53].includes(service.productId));
    return !isEmpty(serviceArr.filter(service => service.productId === productsInfoItem.productId)) && isEmpty(hasMainServices);
};

/**
 * Извлечение айди города из транзакции биллинга. Формат транзакции - айди плюс 11 символов. Например: 49FEKMD53LF91
 * @param transactionId
 * @returns {boolean|number}
 */
export const getCityIdByTransaction = (transactionId) => {
    if (!transactionId) {
        return false;
    }

    const stringedVal = transactionId.toString();

    return parseInt(stringedVal.substring(0, stringedVal.length - 11));
};
